import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AddClients from "./AddClients";
import { Error, Success } from "../../../commons/Messages/Messages";
import axios from "axios";
import DeleteModal from "../../../commons/DeleteModal/DeleteModal";
import defaultImage from "../../../commons/PanelAssets/img/doctors/doctor-01.jpg";
import ClientsGridView from "./ClientsGridView";
import UpdateClient from "./UpdateClient";
import DropdownComp from "../../../commons/Dropdowns/DropdownComp";
import GeneralSegmented from "../../../commons/GeneralSegmented";
import GeneralTable from "../../../commons/GeneralTable";
import SearchBarComp from "../../../commons/SearchBar/SearchBar";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";
import { isAuthenticated } from "../../../commons/Auth/auth";
import Tagcomp from "../../../commons/TagComp/Tagcomp";
import PageToolbar from "../../../design-system/PageToolbar";
import PortalAccessModal, { portalStatusTag } from "../customerPortal/PortalAccessModal";
import { portalStatuses } from "../customerPortal/api";
import { Tag } from "antd";
import "./Clients.css";

import { useTranslation } from "react-i18next";
const Clients = () => {
  const { t } = useTranslation("dashboard");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [layout, setLayout] = useState("list");
  const [totalCount, setTotalCount] = useState("");
  const [searchText, setSearchText] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize] = useState(20);
  // Kundenportal status per customer of the page (empty without the module permission)
  const [portal, setPortal] = useState({});

  const handleSearch = value => {
    setSearchText(value);
    setPageNo(1);
  };

  const deleteClient = async id => {
    try {
      const res = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/users/delete/${id}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      });
      if (res.status === 200 || res.status === 304) {
        Success(res.data.successMessage);
        getData();
      }
    } catch (err) {
      generalErrorAlert(err);
    }
  };

  const columns = [
    {
      title: t("Name"),
      dataIndex: "name",
      mobile: "title",
      render: (text, record) => (
        <>
          {record.firstName} {record.lastName}
        </>
      ),
      sorter: (a, b) => a.firstName.localeCompare(b.firstName)
    },
    {
      title: t("Client ID"),
      dataIndex: "clientId",
      mobile: "hidden",
      sorter: (a, b) => a.employee_id.length - b.employee_id.length
    },
    {
      title: t("Email"),
      dataIndex: "email",
      sorter: (a, b) => a.email.length - b.email.length
    },
    {
      title: t("Mobile"),
      dataIndex: "phone",
      sorter: (a, b) => a.mobile.length - b.mobile.length
    },
    {
      title: t("Company"),
      dataIndex: "company",
      sorter: (a, b) => a.company.length - b.company.length
    },
    {
      title: t("Status"),
      dataIndex: "status",
      mobile: "subtitle",
      render: (text, record) => <Tagcomp text="Active" />
    },
    {
      title: t("Customer portal"),
      dataIndex: "portal",
      mobile: "hidden",
      render: (text, record) => {
        const status = portal[record._id];
        if (!status) return null;
        const tag = portalStatusTag(t, status);
        return <Tag color={tag.color}>{tag.text}</Tag>;
      }
    },
    {
      title: t("Action"),
      key: "action",
      mobile: "actions",
      render: (text, obj) => {
        const menuItems = [
          {
            key: "view",
            link: `/user/clients/projects/${obj?._id}`
          },
          {
            key: "edit",
            component: () => <UpdateClient data={obj} updateParent={getData} />
          },
          {
            key: "portal",
            component: () => <PortalAccessModal client={obj} onChanged={() => loadPortal(data)} />
          },
          {
            key: "delete",
            component: () => <DeleteModal text="Client" onClick={() => deleteClient(obj?._id)} />
          }
        ];
        return (
          <div>
            <DropdownComp menuItems={menuItems} />
          </div>
        );
      }
    }
  ];

  const loadPortal = rows => {
    const ids = (rows || []).map(row => row._id).filter(Boolean);
    if (!ids.length) return;
    portalStatuses(ids)
      .then(res => setPortal(res.data.data || {}))
      .catch(() => setPortal({}));
  };

  const getData = async () => {
    setLoading(true);
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/users/clients/limited`,
        {
          serviceProvider: isAuthenticated()?.serviceProviderId,
          searchText,
          pageSize,
          pageNo: pageNo - 1
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      )
      .then(res => {
        setLoading(false);
        if (res.status === 200 || res.status === 304) {
          setData(res.data?.data);
          setTotalCount(res.data.count);
          loadPortal(res.data?.data);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        setLoading(false);
        if (err.response?.data?.errorMessage) {
          Error(err.response?.data?.errorMessage);
        } else {
          Error(err.message);
        }
      });
  };

  useEffect(() => {
    getData();

    return () => {};
  }, []);

  return (
    <div className="clients-page">
      <PageToolbar
        filters={<SearchBarComp handleSearch={handleSearch} />}
        actions={
          <>
            {/* <GeneralSegmented setLayout={setLayout} /> */}
            <AddClients updateParent={getData} />
          </>
        }
      />
      <GeneralTable
        loading={loading}
        pageNo={pageNo}
        pageSize={pageSize}
        totalCount={totalCount}
        data={data}
        columns={columns}
        setPageNo={setPageNo}
      />
      {/* :
         <ClientsGridView data={data} />
       } */}
    </div>
  );
};

export default Clients;
